/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect } from 'react'
import {
    Card,
    Stack,
    Paper,
    Avatar,
    Button,
    Container,
    Typography,
    IconButton,
    TablePagination,
    ListItemIcon,
    Box,
    TextField,
    Tooltip,
    InputAdornment,
    Grid
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import moment from 'moment';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Label from '../../components/label/Label';
import { sentenceCase } from 'change-case';
import Pagination from '@mui/material/Pagination';
import { OrdersStatus, NumberFormatter } from '../../utils/helper';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import { useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
// redux api 
import { useUserOrdersApiMutation } from '../../redux/services/user/User';

const OrderCard = ({ order, cardNumber, userOrderStatus }) => {
    const { address, landmark, delivery, status, final_amount, created, updated, order_no } = order;
    const createdDate = new Date(created);
    const formattedCreated = createdDate.toLocaleString();

    const updatedDate = new Date(updated);
    const formattedUpdated = updatedDate.toLocaleString();
    return (
        <Card sx={{ display: 'flex', borderLeft: '4px solid green' }}>
            <CardContent sx={{ background: '  #d9e8d9', textAlign: 'center', padding: '14px' }}>
                <Typography variant="h4" color="darkslategray" mt={12}>{cardNumber}</Typography>
            </CardContent>

            <Grid container spacing={2}>
                <Grid item xs={7}>
                    <CardContent>

                        <Box >
                            <Stack direction="row" spacing={2}  >

                                <Stack direction="row" spacing={1}>
                                    <Typography variant="body1" color="gray">Order No:</Typography>
                                    <Typography variant="subtitle2" color="darkslategray">{order_no}</Typography>
                                </Stack>
                                <Stack direction="row" spacing={1}>
                                    <Typography variant="body1" color="gray">created:</Typography>
                                    <Typography variant="subtitle2" color="darkslategray">{formattedCreated} </Typography>
                                </Stack>
                                <Stack direction="row" spacing={1}>
                                    <Typography variant="body1" color="gray">updated:</Typography>
                                    <Typography variant="subtitle2" color="darkslategray"> {formattedUpdated}</Typography>
                                </Stack>

                            </Stack>
                        </Box>
                        <Grid container spacing={2} mt={2}>
                            <Grid item xs={2}>
                                <Typography variant="body1" color="gray">Address:</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle2" color="darkslategray">{address}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}  >
                            <Grid item xs={2}>

                                <Typography variant="body1" color="gray">Landmark:</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle2" color="darkslategray">{landmark}</Typography>
                            </Grid>
                        </Grid>


                        {/* <Divider /> */}
                        <hr />
                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={2}>
                                <Typography variant="body1" color="gray"> Amount:</Typography>

                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle2" color="darkslategray"><NumberFormatter number={final_amount} /></Typography>

                            </Grid>
                        </Grid>
                    </CardContent>
                </Grid>
                <Grid item xs={5}>
                    <Box sx={{ display: 'flex', justifyContent: "end", padding: "22px" }}>
                        <Stack direction="row" spacing={2} >
                            <Typography variant="body1" color="gray">Status:</Typography>
                            <Box>
                                <ListItemIcon >
                                    {userOrderStatus(status)}
                                </ListItemIcon>
                            </Box>
                        </Stack>
                    </Box>
                </Grid>
            </Grid>


        </Card >
    );
};








const UserOrders = () => {
    const [getUserOrders, loaduserOrders] = useUserOrdersApiMutation()
    const [userOrdersData, setUserOrdersData] = useState([])
    const [loadOrders, setLoadOrders] = useState(false)
    const [totalPage, setTotalPage] = useState(0)
    const [currentPage, setCurrentPaeg] = useState(1)
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const { id } = useParams()
    const navigate = useNavigate();

    console.log("userId", id)
    console.log("UserOrderList", userOrdersData)


    const handleDateChange = (newDates) => {
        setStartDate(newDates[0]);
        setEndDate(newDates[1]);
    };
    const userOrdersList = async (from, to) => {
        const body = {
            id: id,
            page: currentPage,
            date_from: from,
            date_to: to
        }
        const result = await getUserOrders(body)
        setUserOrdersData(result?.data)
        setLoadOrders(true)
    }



    useEffect(() => {
        userOrdersList(startDate, endDate)
        setTotalPage(userOrdersData.total)
        setCurrentPaeg(userOrdersData.current)

    }, [loadOrders, totalPage, currentPage, startDate, endDate])
    const handlePageChange = (newPage) => {
        setCurrentPaeg(newPage);
    };


    // const OrdersStatus = (status) => {
    //     switch (status) {
    //         case "WAT":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'warning'}>WATING</Label>
    //             );
    //         case "COF":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'info'}>CONFORM</Label>
    //             );
    //         case "PRE":
    //             return "PREPARING";
    //         case "RDY":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'primary'}>READY</Label>
    //             );
    //         case "OUT":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'default'}>OUT FOR DELIVERY</Label>
    //             );
    //         case "DEL":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'success'}>DELIVERED</Label>
    //             );
    //         case "CAN":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'error'}>CANCELED</Label>
    //             );
    //         case "SCH":
    //             return (
    //                 <Label color={("" === 'banned' && 'error') || 'secondary'}>SCHEDULED</Label>
    //             );
    //         default:
    //             return status;
    //     }
    // }
    return (
        <>
            <Container maxWidth="xl">
                <Box mb={5} mt={2}>
                    <Card sx={{ padding: "15px", }} >
                        <Stack direction="row" justifyContent="space-between" mb={1} mt={1}>
                            <Stack direction="row" >
                                <Button onClick={() => navigate("/dashboard/user")}>
                                    <ArrowBackIcon style={{ color: "blue" }} />
                                </Button>
                                <Typography variant='h4' sx={{ marginTop: "10px" }}>User Orders </Typography>
                            </Stack>
                            <Box sx={{ display: 'flex', justifyContent: "end" }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs} >
                                    <div>
                                        <DateRangePicker

                                            format="MM/DD/YYYY"
                                            value={[startDate, endDate]}
                                            onChange={(dates) => {
                                                if (dates && dates.length === 2) {
                                                    handleDateChange(dates);
                                                } else {
                                                    handleDateChange([null, null]);
                                                }
                                            }}
                                        />
                                    </div>
                                </LocalizationProvider>
                                <Box ml={2} mt={1}>
                                    <Button variant="contained" component={RouterLink} to={`/user-info/${id}`}>Details</Button>
                                </Box>
                            </Box>

                        </Stack>
                    </Card>
                    <Box sx={{ padding: "10px", marginTop: "20px" }} >

                        {
                            loaduserOrders.isLoading ? <Box sx={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box> : (
                                userOrdersData?.list?.map((item, index) => (
                                    <Box key={item.id} mt={2}>
                                        <OrderCard order={item} cardNumber={index + 1} userOrderStatus={OrdersStatus} />
                                    </Box>
                                ))
                            )
                        }

                        <br />

                        <Box mt={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Pagination
                                count={totalPage}
                                page={currentPage}
                                onChange={handlePageChange}
                                className="pagination-root" />
                        </Box>
                    </Box>
                </Box>

                <br />
            </Container >
        </>
    )
}

export default UserOrders
